export const GITHUB_ORG = 'cook-gpt';

export const GITHUB_OWNER = 'charlite';

export const GITHUB_ORG_URL = `https://github.com/${GITHUB_ORG}`;

export const GITHUB_PROFILE_URL = `https://github.com/${GITHUB_OWNER}`;

/** App Store listing name */
export const APP_NAME = 'CookGPT - Gourmet Plan & Taste';

/** Short brand name for compact UI */
export const APP_NAME_SHORT = 'CookGPT';

export const APP_STORE_URL = 'https://apps.apple.com/app/id6805535867';

/** App Store promotional text (170 char max) */
export const APP_STORE_PROMOTIONAL_TEXT =
  'CookGPT — Gourmet Plan & Taste. Start with built-in recipes, auto-schedule your week, and build a grocery list from whatever you planned to cook.';

export const SITE_URL = 'https://cook-gpt.pages.dev';

export const SUPPORT_URL = `${SITE_URL}/contact`;
